import React from "react"
import InstagramIcon from "../../assets/svg/instagram-mono-icon.inline.svg"
import FacebookIcon from "../../assets/svg/facebook-icon.inline.svg"
import TwitterIcon from "../../assets/svg/twitter-icon.inline.svg"
import { socialText, icon } from "./sub-navigation.module.scss"
import Nav from "../bootstrap/nav"
import NavItem from "../bootstrap/nav_item"
import Config from "../../../gatsby-config"

const SubNavSocial = ({ followUs }) => {
  const facebookUrl = Config.siteMetadata.facebookUrl
  const twitterUrl = Config.siteMetadata.twitterUrl
  const instagramUrl = Config.siteMetadata.instagramUrl
  return (
      <Nav as="ul" className="d-flex align-items-center">
        {followUs === true && (
          <NavItem as="li" className={`nav-item d-none d-sm-block me-3 ${socialText}`}>
            Follow Us:
          </NavItem>
        )}

        <NavItem as="li">
          <a href ={facebookUrl} className="nav-link">
            <FacebookIcon
              role="link"
              aria-label="Go to Facebook"
              viewBox="0 0 32 32"
              className={`${icon}  `}
            />
          </a>
        </NavItem>
        <NavItem as="li">
        <a href ={twitterUrl} className="nav-link">
            <TwitterIcon
              role="link"
              aria-label="Go to Twitter"
              className={`${icon}`}
            />
          </a>
        </NavItem>
        <NavItem as="li">
        <a href ={instagramUrl} className="nav-link">
            <InstagramIcon
              role="link"
              aria-label="Go to Instagram"
              viewBox="0 0 32 32"
              className={`${icon}`}
            />
          </a>
        </NavItem>
      </Nav>
  )
}
export default SubNavSocial
